export const DEFAULT_AGENT_ID = "default";

/** Phoenix channel event name used for all AG-UI events. */
export const AG_UI_CHANNEL_EVENT = "ag-ui";
